import { useEffect, useState } from "react";
import { Divider, Flex } from "antd";
import { Button, LexicalEditor } from "ui";
import { useGetLLMS, useUpdateLLMS } from "../api";
import TextArea from "antd/es/input/TextArea";

export const LLMSSettings = () => {
  const [text, setText] = useState<string>("");

  const { data } = useGetLLMS();
  const { mutate, isPending: updating } = useUpdateLLMS();

  useEffect(() => {
    if (data) setText(data?.data);
  }, [data]);

  return (
    <div className="box">
      <h1>ویرایش فایل LLMS</h1>
      <Divider />
      <TextArea
        className={'dir-ltr'}
        autoSize={{ minRows: 30 }}
        value={text}
        onChange={(e) =>
          setText(e.target.value)
        }
      />
      <Divider />
      <Flex justify="flex-end" gap={10}>
        <Button size="large">لغو کردن</Button>
        <Button
          type="primary"
          size="large"
          loading={updating}
          onClick={() => mutate({ text })}
        >
          ذخیره تغییرات
        </Button>
      </Flex>
    </div>
  );
};
